import { createFileRoute, redirect } from '@tanstack/react-router'
import { Skeleton } from 'antd'

export const Route = createFileRoute('/arc/')({
  component: HomePage,
  loader: async () => {
    throw redirect({
      to: '/arc/status/admin',
    })
  },
})

function HomePage() {
  return (
    <div className={'fit-col arc-card'}>
      <Skeleton active />
    </div>
  )
}
